var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home-wrapper fn-flex-col"},[_c('nav-bar'),_c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-content"},[_c('date-nav'),_c('game-panel'),_c('match-panel')],1)])],1),_c('live-foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }